"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettings = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var name = 'GetSettings';
exports.getSettings = (0, api_utils_1.createEndpointFactory)(function () {
    return (0, api_utils_1.createEndpoint)({
        name: name,
        getUrl: function () { return "/settings"; },
        apiToResult: function (data) { return data; },
        resultToJson: function (data) { return data; },
        parseParams: function (params) { return params; },
    });
});
